/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import YesNoSwitch from 'components/input/YesNoSwitch';
import SelectInput from 'components/input/SelectInput';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import BasicContact from './components/BasicContact';
import Employment from './components/Employment';
import Education from './components/Education';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import { getHousehold, getParent2, updateParent2 } from 'app/family/familySlice';
import { formatBoolean, tryParseJSON } from 'components/helper/helper';
import { parent1Rules } from './validation';
import TextInput from 'components/input/textInput';
import DatePickerInput from 'components/input/DatePicker';
import { debounce } from 'lodash';
import Residency from './components/Residency';
import GroupRadioButton from 'components/input/GroupRadioButton';
import collegeServices from 'services/collegeServices';
import Grid from '@mui/joy/Grid';
import { ModalCheckField } from 'screen/common/ModalCheckField';
import { ModalCheckFamilyField } from '../common/ModalCheckMissingField';
import SearchIcon from '@mui/icons-material/Search';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import websocketService from 'services/websocketService';
import familyServices from 'services/familyServices';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

interface Props {}

const Parent2 = (props: Props) => {
  const [loading, setLoading] = React.useState(true);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [showModalCheckField, setShowModalCheckField] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const [chatBoxState, setChatBoxState] = React.useState(false);

  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const [currentParentCollege, setCurrentParentCollege] = React.useState<any[]>([]);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const indexExpand = query.get('index');
  const stepProcess = [
    { title: 'General', percentOnProcess: 25 },
    { title: 'Relationship', percentOnProcess: 40 },
    { title: 'Basic', percentOnProcess: 55 },
    { title: 'Employment', percentOnProcess: 70 },
    { title: 'Education', percentOnProcess: 88 },
  ];
  const relationshipToYouOptions = [
    { value: 'Father' },
    { value: 'Mother' },
    { value: 'Brother' },
    { value: 'Sister' },
    { value: 'Grandfather' },
    { value: 'Grandmother' },
    { value: 'Step Father' },
    { value: 'Step Mother' },
    { value: 'Legal Guardian' },
    { value: 'Other' },
  ];
  const relationshipTypeOptions = [
    { value: 'Mother' },
    { value: 'Father' },
    { value: 'I have limited information about this parent', mdCol: 6 },
    { value: 'I do not have another parent to list', mdCol: 6 },
  ];

  const family = useAppSelector((store) => store.family);
  const formik = useFormik({
    initialValues: {
      is_parent_2_living: true,
      is_parent_2_decesead: false, // not set ?
      date_deceased: '', // from down
      relationship_type: '',
      relationship_to_you: '',
      prefix: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      former_last_name: '',
      suffix: '',
      birth_country: '',
      prefered_email: '',
      country_code: '+1',
      phone_number: '',
      phone_number_type: '',
      parent_address_is: '',
      parent_current_job_status: '',
      job_category: '',
      employment_status: '',
      place_of_work: '',
      ocupation_and_position_title: '',
      number_of_year_at_job: '', // from down
      occupation: '', // in  Employee.tsx
      other_occupation_detail: '', // from down        // vuong added - in  Employee.tsx
      parent_currently_employed_or_retire_from_college: 'Never employed at a college/university',
      education_level: '',
      highest_level_education: '',

      //#region These fields will copy back from fromItem ///////////////////
      total_number_institutions_attended: 0,
      parent_graduation_college_array: [
        {
          degreesNumber: '',
          degreesReceived1: '',
          graduationYear1: '',
          degreesReceived2: '',
          graduationYear2: '',
          degreesReceived3: '',
          graduationYear3: '',
          degreesReceived4: '',
          graduationYear4: '',
          degreesReceived5: '',
          graduationYear5: '',
          school: {
            ceeb: '',
            fib_code: '',
            name: '',
            school_type: null,
            city: '',
            state: '',
            zip: '',
            country: '',
            csu_name: '',
            uc_name: '',
            cm_name: '',
            match_all: false,
            label: '',
            code: null,
            is_manual: false,
            id: '',
            // old fields :
            //   address_line_1: '',
            //   address_line_2: '',
            //   address_line_3: '',
            province: '',
            state_or_province: '',
            //   zip_code: '',
          } as any,
        },
      ],
      //#endregion

      //other_occupation_detail: '',   // move up              in  Employee.tsx

      college_or_university: {
        ceeb: '',
        fib_code: '',
        name: '',
        school_type: null,
        city: '',
        state: '',
        zip: '',
        country: '',
        csu_name: '',
        uc_name: '',
        cm_name: '',
        match_all: false,
        label: '',
        code: null,
        is_manual: false,
        id: '',
        province: '',
        state_or_province: '',
      } as any,
      current_employer: '',
      job_title: '',
      number_of_year_at_home: '',
      number_of_year_not_employed: '',
      number_of_year_retired: '',
      // date_deceased: '', //move up

      other_relationship_to_you_free_text: '',
      different_parent_address_country: '',
      different_parent_address_line_1: '',
      different_parent_address_line_2: '',
      different_parent_address_city: '',
      different_parent_address_state: '',
      different_parent_address_zip_code: '',

      //number_of_year_at_job: 0, // move up

      different_parent_address_province: '', // Vuong added - in BasicContact.tsx

      csu_info: {
        use_chat_box: false,
        is_give_permission_communicate_to: '',
        is_give_permission_to_receive_information: '',
        isCurrentPermanentResidentOfCalifornia: '',
        isLivedInCaliforniaContinuouslySinceBirth: '',
        whenStayInCaliforniaBegin: '',
        priorCountry: '',
        priorState: '',
        fromWhenToWhenLiveThere: '',
        ToWhenToWhenLiveThere: '',
        stateRegardAsPermanentHome: '',
        priorCountry_secondPriorResidency: '',
        priorState_secondPriorResidency: '',
        fromWhenToWhenLiveThere_secondPriorResidency: '',
        ToWhenToWhenLiveThere_secondPriorResidency: '',
        is_authorized_UC_to_share_contact_information: false,
        parent_graduate_within_the_last_five_years: '',
        priorStateOptions: [], // cache options  (from Nghia defined)
        //priorCountryOptions: [],  // cache options  (from Nghia defined) -> move to file components/helper/stateAndCounty.tsx
        //objectCountries: [],      // cache options  (from Nghia defined) -> move to file components/helper/stateAndCounty.tsx
      },
    },
    validationSchema: parent1Rules,
    onSubmit: async (values) => {
      try {
        studentId = getUserId();
        token = getAccessToken();
        if (token && studentId) {
          const newCollegeArray = formItem.values.parent_graduation_college_array.filter((item) => {
            const noSchoolId = !item?.school?.id;

            const allNull = Object.values(item).every((value) => {
              if (value && typeof value === 'object') {
                return Object.values(value).every((val) => !val);
              }
              return !value;
            });

            const notInCurrentParentCollege = !currentParentCollege.some(
              (currentItem) => currentItem?.school?.name === item?.school?.name
            );
            return noSchoolId && notInCurrentParentCollege && !allNull;
          });

          //#region remove priorCountryOption and objectCountries propeties
          let new_csu: any = Object.assign({}, values.csu_info);
          delete new_csu.priorCountryOption;
          delete new_csu.objectCountries;
          //#endregion

          let newValues: any = {
            ...values,
            is_parent_2_living: formatBoolean(values.is_parent_2_living),
            total_number_institutions_attended: Number(
              `${formItem.values.total_number_institutions_attended ?? '0'}`
            ),
            parent_graduation_college_array: JSON.stringify(
              formItem.values.parent_graduation_college_array
            ),
            college_or_university: JSON.stringify(values.college_or_university),
            csu_info: JSON.stringify(new_csu),
            student_id: parseInt(studentId || ''),
            country_code: values.country_code ? values.country_code : '+1',
          };

          //#region Cleanup data before save
          if (newValues) {
            if (
              newValues.parent_currently_employed_or_retire_from_college ===
              'Never employed at a college/university'
            ) {
              newValues.college_or_university = null;
            }
          }
          //#endregion

          //console.log('updateParent2 newValues:', newValues);
          await dispatch(updateParent2(newValues));

          //#region sendMailNewParentCollege
          if (newCollegeArray.length > 0 && formItem.values.is_education_saved) {
            const dataSendmail = {
              student_id: parseInt(studentId || ''),
              parent_name: 'Parent No.2',
              collegesInfo: newCollegeArray,
            };
            await collegeServices.sendMailNewParentCollege(dataSendmail);
          }
          //#endregion
        } else {
          handleLogout();
        }
      } catch (ex) {
        console.log('Error:', ex);
      }
    },
  });
  const formItem = useFormik({
    initialValues: {
      total_number_institutions_attended: '0',
      parent_graduation_college_array: [
        {
          degreesNumber: '',
          degreesReceived1: '',
          graduationYear1: '',
          degreesReceived2: '',
          graduationYear2: '',
          degreesReceived3: '',
          graduationYear3: '',
          degreesReceived4: '',
          graduationYear4: '',
          degreesReceived5: '',
          graduationYear5: '',
          school: {
            ceeb: '',
            fib_code: '',
            name: '',
            school_type: null,
            city: '',
            state: '',
            zip: '',
            country: '',
            csu_name: '',
            uc_name: '',
            cm_name: '',
            match_all: false,
            label: '',
            code: null,
            is_manual: false,
            id: '',
            // old fields :
            //   address_line_1: '',
            //   address_line_2: '',
            //   address_line_3: '',
            province: '',
            state_or_province: '',
            //   zip_code: '',
          } as any,
        },
      ],
      is_education_saved: false, // set true in EducationConfig.tsx
    },
    onSubmit: async (values) => {
      formik.setFieldValue(
        'total_number_institutions_attended',
        Number(values.total_number_institutions_attended)
      );
      formik.setFieldValue(
        'parent_graduation_college_array',
        values.parent_graduation_college_array
      );
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    const nextRoute = Object.keys(family.roleFamily).find(
      (key, index) =>
        index > Object.keys(family.roleFamily).indexOf('parentNo2') &&
        family.roleFamily[key] === true
    );
    formik.handleSubmit();
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.enrolimentStatus.path);
  };

  const handleCheckMissingFields = () => {
    setShowModalCheckField(true);
  };

  const handleCloseModal = () => {
    setShowModalCheckField(false);
  };

  // Prepare data for modal check
  const getModalData = () => {
    return {
      ...formik.values,
      parent_graduation_college_array: formItem.values.parent_graduation_college_array,
    };
  };

  const getDetail = async () => {
    try {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        setLoading(true);
        await dispatch(getHousehold(studentId));
        const pageStatus: {
          student_completed: boolean;
        } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.PARENT_2);
        if (pageStatus) {
          setReviewedAndComplete(pageStatus.student_completed);
        }
        let res = await dispatch(getParent2(studentId));
        const dataLoaded: any = res.payload;
        if (dataLoaded) {
          formik.resetForm({
            values: {
              ...dataLoaded,
              parent_graduation_college_array: tryParseJSON(
                dataLoaded.parent_graduation_college_array
              ),
              college_or_university: tryParseJSON(dataLoaded.college_or_university, {
                name: dataLoaded.college_or_university,
                id: dataLoaded.college_or_university,
                country: '',
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zip_code: '',
              }),
              csu_info: {
                ...formik.values.csu_info,
                ...tryParseJSON(dataLoaded.csu_info),
              },
            },
          });

          formItem.resetForm({
            values: {
              ...formItem.values,
              total_number_institutions_attended:
                dataLoaded.total_number_institutions_attended.toString(),
              parent_graduation_college_array: tryParseJSON(
                dataLoaded.parent_graduation_college_array
              ),
            },
          });

          if (dataLoaded.parent_graduation_college_array) {
            setCurrentParentCollege(tryParseJSON(dataLoaded.parent_graduation_college_array));
          }
        }

        setLoading(false);
        formik.setStatus('idle');
      } else {
        handleLogout();
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  // const getContries = () => {
  //   familyServices
  //     .getContriesCSU()
  //     .then((res: any) => {
  //       let csuCountryTemp: any[] = [];
  //       res.data.map((item: any) => {
  //         csuCountryTemp.push(item.name);
  //       });
  //       formik.setFieldValue('csu_info.priorCountryOptions', csuCountryTemp);
  //       formik.setFieldValue('csu_info.objectCountries', res.data);
  //       console.log('getContries():',  res.data);
  //     })
  //     .catch((err: any) => {
  //       return err;
  //     });
  // };

  React.useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auto save function ==========
  React.useEffect(() => {
    if (family.parent2 !== null) {
      if (formik.dirty && !loading) {
        debounceSaving();
      }
    }
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      formik.handleSubmit();
    }, 1500),
    []
  );
  // Auto save function ==========

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onReviewdAndComplete = () => {
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndComplete(PAGE_NAME.PARENT_2, newValue);
  };

  const handleChatBoxChange = async (e: any) => {
    const isChecked = e.target.checked;
    setChatBoxState(isChecked);
    formik.setFieldValue('csu_info.use_chat_box', isChecked);

    if (isChecked) {
      try {
        const email = formik.values.prefered_email;
        if (email) {
          const emailCheck = await familyServices.checkStudentEmail(email);

          if (emailCheck && emailCheck.data && Object.keys(emailCheck.data).length > 0) {
            // Email exists, save the state
            setChatBoxState(true);
          } else {
            // Email doesn't exist, create parent
            await familyServices.createParent(studentId, {
              email,
            });
          }
        }
      } catch (error) {
        console.log('Error checking email or creating parent:', error);
      }
    }
  };
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={stepProcess}
        title="Family Information"
        process={1}
        icon={<PeopleAltOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden',
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%',
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div id="General" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Parent No. 2
              </span>
            </div>
            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12} md={6}>
                  <div className="text-field-light">Is “Parent No.2” living?</div>
                  <YesNoSwitch
                    // label="Is “Parent No.2” living?"
                    name="is_parent_2_living"
                    values={formik.values.is_parent_2_living}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
                {formatBoolean(formik.values.is_parent_2_living) === false && (
                  <Grid xs={12} md={6}>
                    <DatePickerInput
                      label="Date deceased*"
                      name="date_deceased"
                      values={formik.values.date_deceased}
                      onChange={(value) => formik.setFieldValue('date_deceased', value)}
                      isMissing={!formik.values.date_deceased && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}
              </Grid>
            </div>

            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div
                    id="Relationship"
                    className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}
                  >
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Relationship
                    </span>
                  </div>
                </Grid>
                <Grid xs={12}>
                  <GroupRadioButton
                    label="Type*"
                    logo="span-cm-logo"
                    values={formik.values.relationship_type}
                    columns={2}
                    name="relationship_type"
                    onChange={formik.handleChange}
                    options={relationshipTypeOptions}
                    isMissing={!formik.values.relationship_type && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    option={relationshipToYouOptions}
                    label="Relationship to you*"
                    name="relationship_to_you"
                    values={formik.values.relationship_to_you}
                    onChange={formik.handleChange}
                    isMissing={!formik.values.relationship_to_you && check}
                    disabled={reviewedAndComplete}
                  />
                </Grid>
                {/* <Grid xs={12}>
                  <CheckboxInput
                    setValue={(e) => handleChatBoxChange(e)}
                    label="Use chat box"
                    name="csu_info.use_chat_box"
                    values={formik.values.csu_info.use_chat_box}
                    onChange={handleChatBoxChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid> */}
                {formik.values.relationship_to_you === 'Other' && (
                  <Grid xs={12} md={6}>
                    <TextInput
                      label="Other*"
                      countText={64}
                      name="other_relationship_to_you_free_text"
                      values={formik.values.other_relationship_to_you_free_text}
                      onChange={formik.handleChange}
                      isMissing={!formik.values.other_relationship_to_you_free_text && check}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                )}
              </Grid>
            </div>

            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Basic" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Basic Information
                    </span>
                  </div>
                </Grid>
                <BasicContact
                  formik={formik}
                  check={check}
                  isMobile={isMobile}
                  disabled={reviewedAndComplete}
                />
              </Grid>
            </div>

            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Employment" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Employment
                    </span>
                  </div>
                </Grid>
                <Employment
                  formik={formik}
                  parentNumber={2}
                  check={check}
                  isMobile={isMobile}
                  disabled={reviewedAndComplete}
                />
              </Grid>
            </div>

            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Education" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Education
                    </span>
                  </div>
                </Grid>
                <Education
                  formik={formik}
                  formItem={formItem}
                  check={check}
                  indexExpand={indexExpand}
                  isMobile={isMobile}
                  disabled={reviewedAndComplete}
                />
              </Grid>
            </div>
            <div className={`gm-section-card ${isMobile ? 'p-mobile-1' : ''}`}>
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Residency" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Residency
                    </span>
                  </div>
                </Grid>
                <Residency
                  formik={formik}
                  check={check}
                  isMobile={isMobile}
                  disabled={reviewedAndComplete}
                />
              </Grid>
            </div>

            <div
              className={`gm-form-actions border-top ${
                isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'
              } d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}
            >
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed & Complete!
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div
                className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${
                  isMobile ? '' : 'text-md-end'
                }`}
              >
                <div
                  className={`d-flex ${
                    isMobile ? 'flex-column gap-2' : 'flex-row'
                  } justify-content-center`}
                >
                  <Button
                    variant="primary"
                    type="submit"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto',
                    }}
                  >
                    {family.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto',
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>

      <ModalCheckFamilyField
        show={showModalCheckField}
        onClose={handleCloseModal}
        data={getModalData()}
        page="parent-2"
      />
    </>
  );
};

export default Parent2;
